import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/cjs/styles/prism';

const MarkdownCodeBlock: React.FC<{
  inline?: boolean;
  className?: string;
  children?: React.ReactNode;
}> = ({ inline, className, children, ...props }) => {
  const match = /language-(\w+)/.exec(className || '');
  const language = match?.[1];

  if (!inline && language) {
    return (
      <SyntaxHighlighter
        // react-markdown passes code contents as children
        style={dracula}
        language={language}
        PreTag="div"
        wrapLongLines
        customStyle={{ margin: 0, borderRadius: 8 }}
        {...props}
      >
        {String(children ?? '').replace(/\n$/, '')}
      </SyntaxHighlighter>
    );
  }

  return (
    <code className={className} {...props}>
      {children}
    </code>
  );
};

/** Markdown as participants see it on the competition page (GFM + highlighted code). */
const MarkdownView: React.FC<{ children: string }> = ({ children }) => (
  <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ code: MarkdownCodeBlock }}>
    {children}
  </ReactMarkdown>
);

export default MarkdownView;
